import { Alert } from '@brokerbay/elements-web';
import React, { useContext } from 'react';
import styled from 'styled-components';
import AppointmentBookingInternalContext from '../AppointmentBookingInternalContext';

const BookApprovalInfoAlert: React.FC = () => {
  const { actionButtonsData, partialAppointmentConfig } = useContext(
    AppointmentBookingInternalContext,
  );

  const Messages = {
    autoConfirm:
      'This listing is set up to be automatically confirmed upon booking.',
    advAutoConfirm:
      'The selected date and time is set up to be automatically confirmed upon booking.',
    manualConfirm: 'This listing requires approval to book a showing.',
  } as const;
  let type: keyof typeof Messages = 'manualConfirm';
  if (partialAppointmentConfig!.autoConfirm) {
    type = 'autoConfirm';
  } else if (actionButtonsData.some(data => data.variant === 'autoConfirm')) {
    type = 'advAutoConfirm';
  }

  return (
    <StyledAlert
      data-cy="bookApprovalInfo-alert"
      type="info"
      message={Messages[type]}
      showIcon
      closable
    />
  );
};

const StyledAlert = styled(Alert)`
  && {
    padding: 6px 10px;
    margin-bottom: 8px;
  }
`;

export default BookApprovalInfoAlert;
